export class MesurePhysique {
    Profondeur: number;
    TemperatureBrute: number;
    TemperatureCorrigee: number;
    pH: number;
    Conductivite: number;
    OxygeneDissous: number;
    SaturationO2d: number;
    IsForEauIntegre: boolean;
    
    static mapFromJSON(json: any): MesurePhysique {
        const m = new MesurePhysique();
        m.Profondeur = json.profondeur;
        m.TemperatureBrute = json.temperatureBrute;
        m.TemperatureCorrigee = json.temperatureCorrigee;
        m.pH = json.ph;
        m.Conductivite = json.conductivite;
        m.OxygeneDissous = json.oxygeneDissous;
        m.SaturationO2d = json.saturationO2d;
        m.IsForEauIntegre = json.isForEauIntegre;
        return m;
    }
}